var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11650",
    "data-name": "Group 11650",
    transform: "translate(-813 -306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(813 306)",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-camera-alt",
    "data-name": "Icon material-camera-alt",
    transform: "translate(818.845 311.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12999",
    "data-name": "Path 12999",
    d: "M19.7,16.45a3.25,3.25,0,1,1-3.25-3.25A3.25,3.25,0,0,1,19.7,16.45Z",
    transform: "translate(-3.294 -3.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13000",
    "data-name": "Path 13000",
    d: "M10.109,3,8.25,5.031H5.031A2.037,2.037,0,0,0,3,7.062V19.248a2.037,2.037,0,0,0,2.031,2.031H21.279a2.037,2.037,0,0,0,2.031-2.031V7.062a2.037,2.037,0,0,0-2.031-2.031H18.06L16.2,3Zm3.047,15.233a5.078,5.078,0,1,1,5.078-5.078A5.079,5.079,0,0,1,13.155,18.233Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.d6475518a9d2b7b4f7d1a6aae733ff85.svg";
export { ForwardRef as ReactComponent };